// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Components/SectionCard/sectioncard.css */
/* FINAL VERSION — Perfect Colored Icons + Original Design 100% Preserved */

.section-card {
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  height: 100%;
  position: relative;
  z-index: 1;
}

.section-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 25px -5px rgba(0, 0, 0, 0.15),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  z-index: 2;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.card-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.card-icon-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  opacity: 0.9;
  z-index: -1;
}

/* ICON FIX — Now visible & perfectly colored */
.card-icon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.card-icon svg {
  width: 36px;
  height: 36px;
  stroke: currentColor;
  stroke-width: 2.5;
  fill: none;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

/* PERFECT COLOR MATCHING FOR EACH CARD */
.section-card.blue .card-icon svg      { color: #2563eb; }
.section-card.purple .card-icon svg    { color: #7c3aed; }
.section-card.orange .card-icon svg    { color: #ea580c; }
.section-card.red .card-icon svg       { color: #dc2626; }
.section-card.green .card-icon svg     { color: #16a34a; }
.section-card.teal .card-icon svg      { color: #0d9488; }
.section-card.indigo .card-icon svg    { color: #4338ca; }
.section-card.yellow .card-icon svg    { color: #ca8a04; }
.section-card.brown .card-icon svg     { color: #713f12; }
.section-card.emerald .card-icon svg   { color: #059669; }
.section-card.gray .card-icon svg      { color: #4b5563; }
.section-card.lime .card-icon svg      { color: #65a30d; }
.section-card.pink .card-icon svg      { color: #db2777; }
.section-card.violet .card-icon svg    { color: #7c3aed; }

/* List View Icons — Also Perfectly Colored */
.list-item-icon {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.list-item-icon svg {
  width: 26px;
  height: 26px;
  stroke: currentColor;
  stroke-width: 2.5;
  fill: none;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.3));
}

.section-list-item.blue .list-item-icon svg      { color: #2563eb; }
.section-list-item.purple .list-item-icon svg    { color: #7c3aed; }
.section-list-item.orange .list-item-icon svg    { color: #ea580c; }
.section-list-item.red .list-item-icon svg       { color: #dc2626; }
.section-list-item.green .list-item-icon svg     { color: #16a34a; }
.section-list-item.teal .list-item-icon svg      { color: #0d9488; }
.section-list-item.indigo .list-item-icon svg    { color: #4338ca; }
.section-list-item.yellow .list-item-icon svg    { color: #ca8a04; }
.section-list-item.brown .list-item-icon svg     { color: #713f12; }
.section-list-item.emerald .list-item-icon svg   { color: #059669; }
.section-list-item.gray .list-item-icon svg      { color: #4b5563; }
.section-list-item.lime .list-item-icon svg      { color: #65a30d; }
.section-list-item.pink .list-item-icon svg      { color: #db2777; }
.section-list-item.violet .list-item-icon svg    { color: #7c3aed; }

/* Your Original Beautiful Gradient Backgrounds — 100% Preserved */
.section-card.blue .card-icon-container::before,
.section-list-item.blue .list-item-icon-container::before {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
}
.section-card.purple .card-icon-container::before,
.section-list-item.purple .list-item-icon-container::before {
  background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
}
.section-card.orange .card-icon-container::before,
.section-list-item.orange .list-item-icon-container::before {
  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);
}
.section-card.red .card-icon-container::before,
.section-list-item.red .list-item-icon-container::before {
  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);
}
.section-card.green .card-icon-container::before,
.section-list-item.green .list-item-icon-container::before {
  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);
}
.section-card.teal .card-icon-container::before,
.section-list-item.teal .list-item-icon-container::before {
  background: linear-gradient(135deg, #14b8a6 0%, #2dd4bf 100%);
}
.section-card.indigo .card-icon-container::before,
.section-list-item.indigo .list-item-icon-container::before {
  background: linear-gradient(135deg, #4f46e5 0%, #818cf8 100%);
}
.section-card.yellow .card-icon-container::before,
.section-list-item.yellow .list-item-icon-container::before {
  background: linear-gradient(135deg, #eab308 0%, #facc15 100%);
}
.section-card.brown .card-icon-container::before,
.section-list-item.brown .list-item-icon-container::before {
  background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
}
.section-card.emerald .card-icon-container::before,
.section-list-item.emerald .list-item-icon-container::before {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
}
.section-card.gray .card-icon-container::before,
.section-list-item.gray .list-item-icon-container::before {
  background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);
}
.section-card.lime .card-icon-container::before,
.section-list-item.lime .list-item-icon-container::before {
  background: linear-gradient(135deg, #84cc16 0%, #a3e635 100%);
}
.section-card.pink .card-icon-container::before,
.section-list-item.pink .list-item-icon-container::before {
  background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);
}
.section-card.violet .card-icon-container::before,
.section-list-item.violet .list-item-icon-container::before {
  background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
}

/* Hover Effects — Fully Preserved */
.section-card.blue:hover      { border: 1px solid #3b82f6; }
.section-card.purple:hover    { border: 1px solid #8b5cf6; }
.section-card.orange:hover    { border: 1px solid #f97316; }
.section-card.red:hover       { border: 1px solid #ef4444; }
.section-card.green:hover     { border: 1px solid #22c55e; }
.section-card.teal:hover      { border: 1px solid #14b8a6; }
.section-card.indigo:hover    { border: 1px solid #4f46e5; }
.section-card.yellow:hover    { border: 1px solid #eab308; }
.section-card.brown:hover     { border: 1px solid #78350f; }
.section-card.emerald:hover   { border: 1px solid #10b981; }
.section-card.gray:hover      { border: 1px solid #6b7280; }
.section-card.lime:hover      { border: 1px solid #84cc16; }
.section-card.pink:hover      { border: 1px solid #ec4899; }
.section-card.violet:hover    { border: 1px solid #8b5cf6; }

.section-card:hover .card-action-button.primary {
  background-color: var(--color-primary, #3b82f6);
  border-color: var(--color-primary, #3b82f6);
  color: white;
}

.section-card:hover .card-action-button.secondary {
  background-color: #f8fafc;
}

/* All Original Styles — Menus, Buttons, Text, etc. */
.card-menu { display: flex; gap: 0.5rem; }

.card-favorite-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  color: #94a3b8;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  opacity: 0;
}

.card-favorite-button.active { color: #f59e0b; opacity: 1; }
.section-card:hover .card-favorite-button { opacity: 1; }
.card-favorite-button:hover { background-color: #f1f5f9; color: #f59e0b; }

.card-menu-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  color: #64748b;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s ease, transform 0.3s ease, background-color 0.2s;
  opacity: 0;
  transform: translateY(-5px);
}

.section-card:hover .card-menu-button { opacity: 1; transform: translateY(0); }
.card-menu-button:hover { background-color: #f1f5f9; color: #1e293b; }

.card-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  width: 160px;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  z-index: 10;
  overflow: hidden;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.card-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: 0.875rem;
  color: #475569;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.card-dropdown-item:hover { background-color: #f8fafc; color: #1e293b; }
.card-dropdown-item.danger { color: #ef4444; }
.card-dropdown-item.danger:hover { background-color: #fef2f2; }

.card-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.75rem;
  transition: color 0.3s ease;
}

.section-card:hover .card-title { color: var(--color-primary, #3b82f6); }

.card-stats {
  margin-top: auto;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.card-count {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  transition: color 0.3s ease;
}

.section-card:hover .card-count { color: var(--color-primary, #3b82f6); }

.card-label { font-size: 0.875rem; color: #64748b; }

.card-actions { display: flex; gap: 0.75rem; }

.card-action-button {
  padding: 0.625rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.card-action-button.primary {
  background-color: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
  flex: 1 1;
}

.card-action-button.secondary {
  background-color: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
  padding: 0.625rem;
  width: 2.5rem;
}

/* List View */
.section-list-item {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.section-list-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.list-item-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;
  margin-right: 1rem;
  flex-shrink: 0;
}

.list-item-icon-container::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  border-radius: inherit;
  opacity: 0.9;
  z-index: -1;
}

.list-item-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  flex: 1 1;
}

.list-item-count {
  font-size: 0.875rem;
  color: #64748b;
  margin-right: 2rem;
}

.list-item-count span {
  font-weight: 600;
  color: #1e293b;
}

.list-item-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}


/* CSS Variables — Unchanged */
.section-card.blue, .section-list-item.blue       { --color-primary: #3b82f6; }
.section-card.purple, .section-list-item.purple   { --color-primary: #8b5cf6; }
.section-card.orange, .section-list-item.orange   { --color-primary: #f97316; }
.section-card.red, .section-list-item.red         { --color-primary: #ef4444; }
.section-card.green, .section-list-item.green     { --color-primary: #22c55e; }
.section-card.teal, .section-list-item.teal       { --color-primary: #14b8a6; }
.section-card.indigo, .section-list-item.indigo   { --color-primary: #4f46e5; }
.section-card.yellow, .section-list-item.yellow   { --color-primary: #eab308; }
.section-card.brown, .section-list-item.brown     { --color-primary: #78350f; }
.section-card.emerald, .section-list-item.emerald { --color-primary: #10b981; }
.section-card.gray, .section-list-item.gray       { --color-primary: #6b7280; }
.section-card.lime, .section-list-item.lime       { --color-primary: #84cc16; }
.section-card.pink, .section-list-item.pink       { --color-primary: #ec4899; }
.section-card.violet, .section-list-item.violet   { --color-primary: #8b5cf6; }

/* Responsive */
@media (max-width: 640px) {
  .card-menu-button { opacity: 1; transform: translateY(0); }
  .card-icon-container { width: 3rem; height: 3rem; }
  .card-title { font-size: 1rem; }
  .card-count { font-size: 1.25rem; }
}`, "",{"version":3,"sources":["webpack://./src/Components/SectionCard/sectioncard.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C,2EAA2E;;AAE3E;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,4DAA4D;EAC5D,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;sCACoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,iDAAiD;AACnD;;AAEA,yCAAyC;AACzC,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;;AAEzD,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,UAAU;EACV,iDAAiD;AACnD;;AAEA,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;AACnE,mDAAmD,cAAc,EAAE;;AAEnE,kEAAkE;AAClE;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;AACA;;EAEE,6DAA6D;AAC/D;;AAEA,oCAAoC;AACpC,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;;AAE3D;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD,aAAa,aAAa,EAAE,WAAW,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA,+BAA+B,cAAc,EAAE,UAAU,EAAE;AAC3D,4CAA4C,UAAU,EAAE;AACxD,8BAA8B,yBAAyB,EAAE,cAAc,EAAE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yEAAyE;EACzE,UAAU;EACV,2BAA2B;AAC7B;;AAEA,wCAAwC,UAAU,EAAE,wBAAwB,EAAE;AAC9E,0BAA0B,yBAAyB,EAAE,cAAc,EAAE;;AAErE;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,mFAAmF;EACnF,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;AACvE,6BAA6B,cAAc,EAAE;AAC7C,mCAAmC,yBAAyB,EAAE;;AAE9D;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,kCAAkC,oCAAoC,EAAE;;AAExE;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,kCAAkC,oCAAoC,EAAE;;AAExE,cAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD,gBAAgB,aAAa,EAAE,YAAY,EAAE;;AAE7C;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;;AAGA,8BAA8B;AAC9B,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;AAC9E,oDAAoD,wBAAwB,EAAE;;AAE9E,eAAe;AACf;EACE,oBAAoB,UAAU,EAAE,wBAAwB,EAAE;EAC1D,uBAAuB,WAAW,EAAE,YAAY,EAAE;EAClD,cAAc,eAAe,EAAE;EAC/B,cAAc,kBAAkB,EAAE;AACpC","sourcesContent":["/* src/Components/SectionCard/sectioncard.css */\n/* FINAL VERSION — Perfect Colored Icons + Original Design 100% Preserved */\n\n.section-card {\n  background-color: #ffffff;\n  border-radius: 1rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  overflow: hidden;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.section-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 25px -5px rgba(0, 0, 0, 0.15),\n    0 8px 10px -6px rgba(0, 0, 0, 0.1);\n}\n\n.card-content {\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.25rem;\n}\n\n.card-icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: hidden;\n}\n\n.card-icon-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: inherit;\n  opacity: 0.9;\n  z-index: -1;\n}\n\n/* ICON FIX — Now visible & perfectly colored */\n.card-icon {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.card-icon svg {\n  width: 36px;\n  height: 36px;\n  stroke: currentColor;\n  stroke-width: 2.5;\n  fill: none;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n/* PERFECT COLOR MATCHING FOR EACH CARD */\n.section-card.blue .card-icon svg      { color: #2563eb; }\n.section-card.purple .card-icon svg    { color: #7c3aed; }\n.section-card.orange .card-icon svg    { color: #ea580c; }\n.section-card.red .card-icon svg       { color: #dc2626; }\n.section-card.green .card-icon svg     { color: #16a34a; }\n.section-card.teal .card-icon svg      { color: #0d9488; }\n.section-card.indigo .card-icon svg    { color: #4338ca; }\n.section-card.yellow .card-icon svg    { color: #ca8a04; }\n.section-card.brown .card-icon svg     { color: #713f12; }\n.section-card.emerald .card-icon svg   { color: #059669; }\n.section-card.gray .card-icon svg      { color: #4b5563; }\n.section-card.lime .card-icon svg      { color: #65a30d; }\n.section-card.pink .card-icon svg      { color: #db2777; }\n.section-card.violet .card-icon svg    { color: #7c3aed; }\n\n/* List View Icons — Also Perfectly Colored */\n.list-item-icon {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.list-item-icon svg {\n  width: 26px;\n  height: 26px;\n  stroke: currentColor;\n  stroke-width: 2.5;\n  fill: none;\n  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.3));\n}\n\n.section-list-item.blue .list-item-icon svg      { color: #2563eb; }\n.section-list-item.purple .list-item-icon svg    { color: #7c3aed; }\n.section-list-item.orange .list-item-icon svg    { color: #ea580c; }\n.section-list-item.red .list-item-icon svg       { color: #dc2626; }\n.section-list-item.green .list-item-icon svg     { color: #16a34a; }\n.section-list-item.teal .list-item-icon svg      { color: #0d9488; }\n.section-list-item.indigo .list-item-icon svg    { color: #4338ca; }\n.section-list-item.yellow .list-item-icon svg    { color: #ca8a04; }\n.section-list-item.brown .list-item-icon svg     { color: #713f12; }\n.section-list-item.emerald .list-item-icon svg   { color: #059669; }\n.section-list-item.gray .list-item-icon svg      { color: #4b5563; }\n.section-list-item.lime .list-item-icon svg      { color: #65a30d; }\n.section-list-item.pink .list-item-icon svg      { color: #db2777; }\n.section-list-item.violet .list-item-icon svg    { color: #7c3aed; }\n\n/* Your Original Beautiful Gradient Backgrounds — 100% Preserved */\n.section-card.blue .card-icon-container::before,\n.section-list-item.blue .list-item-icon-container::before {\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n}\n.section-card.purple .card-icon-container::before,\n.section-list-item.purple .list-item-icon-container::before {\n  background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);\n}\n.section-card.orange .card-icon-container::before,\n.section-list-item.orange .list-item-icon-container::before {\n  background: linear-gradient(135deg, #f97316 0%, #fb923c 100%);\n}\n.section-card.red .card-icon-container::before,\n.section-list-item.red .list-item-icon-container::before {\n  background: linear-gradient(135deg, #ef4444 0%, #f87171 100%);\n}\n.section-card.green .card-icon-container::before,\n.section-list-item.green .list-item-icon-container::before {\n  background: linear-gradient(135deg, #22c55e 0%, #4ade80 100%);\n}\n.section-card.teal .card-icon-container::before,\n.section-list-item.teal .list-item-icon-container::before {\n  background: linear-gradient(135deg, #14b8a6 0%, #2dd4bf 100%);\n}\n.section-card.indigo .card-icon-container::before,\n.section-list-item.indigo .list-item-icon-container::before {\n  background: linear-gradient(135deg, #4f46e5 0%, #818cf8 100%);\n}\n.section-card.yellow .card-icon-container::before,\n.section-list-item.yellow .list-item-icon-container::before {\n  background: linear-gradient(135deg, #eab308 0%, #facc15 100%);\n}\n.section-card.brown .card-icon-container::before,\n.section-list-item.brown .list-item-icon-container::before {\n  background: linear-gradient(135deg, #78350f 0%, #92400e 100%);\n}\n.section-card.emerald .card-icon-container::before,\n.section-list-item.emerald .list-item-icon-container::before {\n  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n}\n.section-card.gray .card-icon-container::before,\n.section-list-item.gray .list-item-icon-container::before {\n  background: linear-gradient(135deg, #6b7280 0%, #9ca3af 100%);\n}\n.section-card.lime .card-icon-container::before,\n.section-list-item.lime .list-item-icon-container::before {\n  background: linear-gradient(135deg, #84cc16 0%, #a3e635 100%);\n}\n.section-card.pink .card-icon-container::before,\n.section-list-item.pink .list-item-icon-container::before {\n  background: linear-gradient(135deg, #ec4899 0%, #f472b6 100%);\n}\n.section-card.violet .card-icon-container::before,\n.section-list-item.violet .list-item-icon-container::before {\n  background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);\n}\n\n/* Hover Effects — Fully Preserved */\n.section-card.blue:hover      { border: 1px solid #3b82f6; }\n.section-card.purple:hover    { border: 1px solid #8b5cf6; }\n.section-card.orange:hover    { border: 1px solid #f97316; }\n.section-card.red:hover       { border: 1px solid #ef4444; }\n.section-card.green:hover     { border: 1px solid #22c55e; }\n.section-card.teal:hover      { border: 1px solid #14b8a6; }\n.section-card.indigo:hover    { border: 1px solid #4f46e5; }\n.section-card.yellow:hover    { border: 1px solid #eab308; }\n.section-card.brown:hover     { border: 1px solid #78350f; }\n.section-card.emerald:hover   { border: 1px solid #10b981; }\n.section-card.gray:hover      { border: 1px solid #6b7280; }\n.section-card.lime:hover      { border: 1px solid #84cc16; }\n.section-card.pink:hover      { border: 1px solid #ec4899; }\n.section-card.violet:hover    { border: 1px solid #8b5cf6; }\n\n.section-card:hover .card-action-button.primary {\n  background-color: var(--color-primary, #3b82f6);\n  border-color: var(--color-primary, #3b82f6);\n  color: white;\n}\n\n.section-card:hover .card-action-button.secondary {\n  background-color: #f8fafc;\n}\n\n/* All Original Styles — Menus, Buttons, Text, etc. */\n.card-menu { display: flex; gap: 0.5rem; }\n\n.card-favorite-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.375rem;\n  color: #94a3b8;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  opacity: 0;\n}\n\n.card-favorite-button.active { color: #f59e0b; opacity: 1; }\n.section-card:hover .card-favorite-button { opacity: 1; }\n.card-favorite-button:hover { background-color: #f1f5f9; color: #f59e0b; }\n\n.card-menu-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.375rem;\n  color: #64748b;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.3s ease, transform 0.3s ease, background-color 0.2s;\n  opacity: 0;\n  transform: translateY(-5px);\n}\n\n.section-card:hover .card-menu-button { opacity: 1; transform: translateY(0); }\n.card-menu-button:hover { background-color: #f1f5f9; color: #1e293b; }\n\n.card-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 160px;\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  z-index: 10;\n  overflow: hidden;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.card-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  color: #475569;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.card-dropdown-item:hover { background-color: #f8fafc; color: #1e293b; }\n.card-dropdown-item.danger { color: #ef4444; }\n.card-dropdown-item.danger:hover { background-color: #fef2f2; }\n\n.card-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 0.75rem;\n  transition: color 0.3s ease;\n}\n\n.section-card:hover .card-title { color: var(--color-primary, #3b82f6); }\n\n.card-stats {\n  margin-top: auto;\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.card-count {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  transition: color 0.3s ease;\n}\n\n.section-card:hover .card-count { color: var(--color-primary, #3b82f6); }\n\n.card-label { font-size: 0.875rem; color: #64748b; }\n\n.card-actions { display: flex; gap: 0.75rem; }\n\n.card-action-button {\n  padding: 0.625rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.card-action-button.primary {\n  background-color: transparent;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n  flex: 1;\n}\n\n.card-action-button.secondary {\n  background-color: transparent;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n  padding: 0.625rem;\n  width: 2.5rem;\n}\n\n/* List View */\n.section-list-item {\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 0.75rem;\n  padding: 1rem 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.section-list-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.list-item-icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.5rem;\n  position: relative;\n  overflow: hidden;\n  margin-right: 1rem;\n  flex-shrink: 0;\n}\n\n.list-item-icon-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  border-radius: inherit;\n  opacity: 0.9;\n  z-index: -1;\n}\n\n.list-item-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n  flex: 1;\n}\n\n.list-item-count {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-right: 2rem;\n}\n\n.list-item-count span {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.list-item-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n\n/* CSS Variables — Unchanged */\n.section-card.blue, .section-list-item.blue       { --color-primary: #3b82f6; }\n.section-card.purple, .section-list-item.purple   { --color-primary: #8b5cf6; }\n.section-card.orange, .section-list-item.orange   { --color-primary: #f97316; }\n.section-card.red, .section-list-item.red         { --color-primary: #ef4444; }\n.section-card.green, .section-list-item.green     { --color-primary: #22c55e; }\n.section-card.teal, .section-list-item.teal       { --color-primary: #14b8a6; }\n.section-card.indigo, .section-list-item.indigo   { --color-primary: #4f46e5; }\n.section-card.yellow, .section-list-item.yellow   { --color-primary: #eab308; }\n.section-card.brown, .section-list-item.brown     { --color-primary: #78350f; }\n.section-card.emerald, .section-list-item.emerald { --color-primary: #10b981; }\n.section-card.gray, .section-list-item.gray       { --color-primary: #6b7280; }\n.section-card.lime, .section-list-item.lime       { --color-primary: #84cc16; }\n.section-card.pink, .section-list-item.pink       { --color-primary: #ec4899; }\n.section-card.violet, .section-list-item.violet   { --color-primary: #8b5cf6; }\n\n/* Responsive */\n@media (max-width: 640px) {\n  .card-menu-button { opacity: 1; transform: translateY(0); }\n  .card-icon-container { width: 3rem; height: 3rem; }\n  .card-title { font-size: 1rem; }\n  .card-count { font-size: 1.25rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
